export default function isDummyTransaction(transaction: {paymentType?: string}) {
  if (transaction.paymentType === 'commanderPaymentRequest') {
    return true
  }

  return false
}
